// @core/api/endpoints/authn/update_oauth2_client.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  OAuth2ClientResponse,
  UpdateOAuth2ClientRequest,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Update OAuth2 client
 * Updates OAuth2 client configuration including name, redirect URIs, allowed scopes, and grant types. Cannot modify the client secret through this endpoint.
 */
export async function UpdateOAuth2Client(
  client_id: string,
  data: UpdateOAuth2ClientRequest,
  options?: RequestOptions
): Promise<OAuth2ClientResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/oauth2/clients/:client_id`;
  requestPath = requestPath.replace(':client_id', encodeURIComponent(client_id));
  const requestOptions = options;
  return client.put<OAuth2ClientResponse>(requestPath, data, requestOptions);
}
